import { TableCell, Typography } from "@mui/material";
import { dateTimeConversionService } from "../../../shared/services/DateTimeConversionService";
import {
    TABLE_EXPIRATION_EXP_CELL_FONT_SIZE,
    TABLE_EXPIRATION_PRICE_UNAVAILABLE_TEXT,
} from "../../shared/constants/table.constants";
import { numberFormatters } from "../../shared/utils/numberFormatters";
import { ApplicationTooltip } from "./ApplicationTooltip";

type OptionExpirationTableCellProps = {
    isOption: boolean;
    expireAt: Date | null;
    expirationPrice: number | null;
    textColour?: string;
};

type OptionExpirationDisplayInfo = {
    text: string | null;
    tooltip: string | null;
};

const EXPIRATION_PRICE_UNAVAILABLE_TOOLTIP = "Expiration price is not available yet.";

export function OptionExpirationTableCell({
    isOption,
    expireAt,
    expirationPrice,
    textColour,
}: OptionExpirationTableCellProps) {
    const getDisplayInfo = (): OptionExpirationDisplayInfo => {
        if (!isOption) {
            return { text: null, tooltip: null };
        }

        if (expirationPrice !== null) {
            return {
                text: numberFormatters.format0(expirationPrice),
                tooltip: null,
            };
        }

        if (expireAt === null) {
            return { text: null, tooltip: null };
        }

        const hasExpirationDatePassed =
            new Date(expireAt).getTime() <= dateTimeConversionService.getCurrentUtcDate().getTime();

        if (hasExpirationDatePassed) {
            return {
                text: TABLE_EXPIRATION_PRICE_UNAVAILABLE_TEXT,
                tooltip: EXPIRATION_PRICE_UNAVAILABLE_TOOLTIP,
            };
        }

        return {
            text: dateTimeConversionService.getExpirationPeriodInfoText(expireAt),
            tooltip: null,
        };
    };

    const displayInfo = getDisplayInfo();

    return (
        <ApplicationTooltip
            title={displayInfo.tooltip}
            disableInteractive
            offset={[0, -7]}
        >
            <TableCell align="right">
                <Typography
                    noWrap
                    sx={{
                        fontSize: TABLE_EXPIRATION_EXP_CELL_FONT_SIZE,
                        textOverflow: 'ellipsis',
                        color: textColour,
                    }}
                >
                    {displayInfo.text}
                </Typography>
            </TableCell>
        </ApplicationTooltip>
    );
}
